// opervex-frontend/src/Opervex/System/Layouts.js

class Layouts {
  #_api; // Definição de campo privado

  constructor(api) {
    this.#_api = api;
  }

  async findOne(report, variant) {
    return this.#_api.get(`/System/Layouts/${report}/${variant}`);
  }

  async save(data) {
    return this.#_api.post("/System/Layouts/", data);
  }

  async delete(report, variant) {
    return this.#_api.delete(`/System/Layouts/${report}/${variant}`);
  }

  async schema() {
    return [
      {
        key: "variant",
        label: "Variante",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "text",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default Layouts;
